import type { MapLayer } from "@/types/cta-mapa-ui";

interface MapLayerControlProps {
  layers: MapLayer[];
  onToggleLayer: (layerId: string) => void;
  open: boolean;
  onClose: () => void;
}

const categorias: { key: MapLayer["categoria"]; label: string }[] = [
  { key: "individuos", label: "Exemplares arbóreos" },
  { key: "territorio", label: "Base territorial" },
  { key: "referencia", label: "Referência externa" },
];

/** Camadas com fonte real.  O mapa-base (Híbrido, Satélite, Ruas) e trocado no proprio mapa. */
export default function MapLayerControl({ layers, onToggleLayer, open, onClose }: MapLayerControlProps) {
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose}></div>
      <div className="absolute top-12 right-2 w-72 bg-white border border-background-200 rounded-card shadow-lg z-50">
        <div className="flex items-center justify-between px-4 py-3 border-b border-background-200/70">
          <div className="flex items-center gap-2">
            <i className="ri-stack-line text-accent-500 text-base" aria-hidden="true"></i>
            <span className="text-sm font-semibold text-foreground-900 font-heading whitespace-nowrap">Camadas</span>
          </div>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-background-100 transition-colors" title="Fechar">
            <i className="ri-close-line text-foreground-500 text-base"></i>
          </button>
        </div>

        <div className="p-3 space-y-3 max-h-[min(70vh,34rem)] overflow-y-auto">
          {categorias.map((cat) => {
            const catLayers = layers.filter((l) => l.categoria === cat.key);
            if (catLayers.length === 0) return null;
            return (
              <div key={cat.key}>
                <p className="text-[10px] font-semibold text-foreground-500 uppercase tracking-wider mb-1.5">{cat.label}</p>
                <div className="space-y-1">
                  {catLayers.map((layer) => (
                    <label
                      key={layer.id}
                      className="flex items-center gap-2.5 py-1.5 px-2 rounded-md hover:bg-background-50 transition-colors cursor-pointer"
                    >
                      <input type="checkbox" checked={layer.ativa} onChange={() => onToggleLayer(layer.id)} className="sr-only" />
                      <div
                        className={`w-4 h-4 rounded border-2 flex items-center justify-center transition-colors ${
                          layer.ativa ? "bg-accent-500 border-accent-500" : "border-background-300 bg-white"
                        }`}
                      >
                        {layer.ativa && <i className="ri-check-line text-white text-[10px]"></i>}
                      </div>
                      <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: layer.cor }} aria-hidden="true"></span>
                      <span className="text-xs text-foreground-700">
                        {layer.nome}
                        {layer.descricao && <span className="block text-[10px] text-foreground-400 leading-tight">{layer.descricao}</span>}
                      </span>
                      <i className={`${layer.icone} text-foreground-400 text-xs ml-auto`} aria-hidden="true"></i>
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
